import React, { type ReactNode, Children } from "react";
import { Flex, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
import { ChevronDownIcon } from "ui/icons";
import Balancer from "react-wrap-balancer";
import { remCalc } from "theme/utils";

export function MdxAccordion({ children }: { children?: ReactNode }) {
  const arrayChildren = Children.toArray(children);
  const heading = arrayChildren?.slice(0, 1);
  const details = arrayChildren?.slice(1);
  return (
    <AccordionItem borderBottom="1px solid" borderTop="none" borderBottomColor="base.border">
      {({ isExpanded }) => (
        <>
          <AccordionButton py={8} px={0} _hover={{ bg: "white" }} role="group">
            <Flex justify="space-between" w="full" align="center" textAlign="left" gap={4} sx={{ "& h2": { my: 0 } }}>
              <Balancer>{heading}</Balancer>
              <Flex
                align="center"
                borderRadius="full"
                bg="brand.backgroundSecondary.light"
                color="brand.text.light"
                boxSize={remCalc(48)}
                flexShrink={0}
                justify="center"
              >
                <ChevronDownIcon
                  transform={isExpanded ? "rotate(180deg)" : "none"}
                  transition="transform 0.25s ease-in-out"
                />
              </Flex>
            </Flex>
          </AccordionButton>
          <AccordionPanel py={2} px={0}>
            {details}
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
}
